export const removeHTMLTags = (value: string) =>
  value
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/(<([^>]+)>)/gi, '')
    .replace(/\s+/g, ' ')
    .trim()
